(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-with-btt"] && !Shopify.designMode) return;
  try {
    
(function() {
  const uniqueButtonPrefix = 'uniqueBTT-'; // 与 HTML 中 ID 前缀一致

  // 单个按钮的滚动处理函数 (所有按钮共享)
  function scrollToTopHandler() {
    // 'this' 在这里将指向被点击的按钮元素
    console.log(`[BTT] Button clicked (ID: ${this.id}). Scrolling to top.`);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // 初始化单个分区内的按钮
  function initializeButtonForSection(sectionElement) {
    if (!sectionElement) return;

    const sectionId = sectionElement.dataset.sectionId;
    if (!sectionId) {
      // console.warn('[BTT] Section element missing data-section-id.');
      return;
    }

    const buttonId = uniqueButtonPrefix + sectionId;
    const backToTopButton = sectionElement.querySelector('#' + buttonId);

    if (backToTopButton) {
      // 移除旧监听器以防重复添加 (尤其在 section:load 时)
      backToTopButton.removeEventListener('click', scrollToTopHandler);
      backToTopButton.addEventListener('click', scrollToTopHandler);
      // console.log(`[BTT] Event listener attached to button #${buttonId} in section ${sectionId}.`);
    } else {
      // console.warn(`[BTT] Button #${buttonId} not found in section ${sectionId}.`);
    }
  }

  // 初始化页面上所有已存在的 BTT 分区
  function initializeAllExistingBTTSections() {
    // console.log('[BTT] Initializing all existing BTT sections on DOMContentLoaded.');
    const sections = document.querySelectorAll('.btt-section-instance');
    sections.forEach(sectionElement => {
      initializeButtonForSection(sectionElement);
    });
  }


  document.addEventListener('DOMContentLoaded', initializeAllExistingBTTSections);


  document.addEventListener('shopify:section:load', function(event) {
    const sectionElement = document.querySelector(`.btt-section-instance[data-section-id="${event.detail.sectionId}"]`);
    if (sectionElement) {
      // console.log(`[BTT] Shopify section:load event for ${event.detail.sectionId}. Initializing button.`);
      initializeButtonForSection(sectionElement);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const sectionElement = document.querySelector(`.btt-section-instance[data-section-id="${event.detail.sectionId}"]`);
    if (sectionElement) {
      const sectionId = sectionElement.dataset.sectionId;
      const buttonId = uniqueButtonPrefix + sectionId;
      const backToTopButton = sectionElement.querySelector('#' + buttonId);
      if (backToTopButton) {
        backToTopButton.removeEventListener('click', scrollToTopHandler);
        // console.log(`[BTT] Event listener removed from #${buttonId} on section unload for ${sectionId}.`);
      }
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
